export default __webpack_public_path__ + "static/Scroll-Image---Septic-Tank-Removal-3688ccffea16172a17a7ea0b7fc038a3.jpg";